import { Col, Row, Select } from 'antd';
import moment from 'moment';
import React, { Component } from 'react';
import { renderPaymentTerms, renderPreferredTime, renderRowCurrency } from './../../../../components/render-select';
import { preferredTime, needCollectAmountTerms } from './../../../../constants';
import { dateFormat } from './../../../../services/ruleValidate';
import { orderStatus } from '../../../../constants';
import './styles.css';
import InputFormat from './../../../../components/input-format';

class ShipmentOptionsComponent extends Component {
    onChangeInformation = (value, column) => {
        this.props.onChangeInformation({ value, column })
        this.props.pageType === 'editOrder' && this.props.onChange({ value: false, column: 'buttonEditOrderDisabled' })
    }

    render() {
        const { information, shipperInformation, classes } = this.props
        var toViewCollectAmount = false;
        if(needCollectAmountTerms.includes(information.terms))
        {
            toViewCollectAmount = true;
        }
        return (
            <Col span={8} id="shipment-options">
                <Row gutter={16}>
                    <Col span={9} className="size-order-col-1">
                        <h1 className='title title-field'>SHIPMENT OPTIONS</h1>
                    </Col>
                    <Col span={15} className="size-order-col-2">
                        <div className="gutter-box">
                            <h3 className='title-field'>TERMS</h3>
                            <Select
                                className={`select-gutter-box ${classes['terms']}`}
                                onChange={value => this.onChangeInformation(value, 'terms')}
                                value={information.terms.toString()}
                                disabled={information.save_item || information.status_id === orderStatus.SPLIT}
                            >
                                {renderPaymentTerms(String(shipperInformation.paymentTerms), shipperInformation.defaultPaymentTerm, information.channel_short_name, information.country)}
                            </Select>
                        </div>
                        <div className="gutter-box">
                            <h3 className='title-field'>PREFERRED DELIVERY TIME</h3>
                            <Select
                                className="select-gutter-box"
                                onChange={value => this.onChangeInformation(value, 'preferred_time')}
                                value={information.preferred_time}
                                disabled={information.save_item || information.status_id === orderStatus.SPLIT}
                            >
                                {renderPreferredTime(preferredTime)}
                            </Select>
                        </div>
                        <div className="gutter-box">
                            <h3 className='title-field'>CURRENCY</h3>
                            <Select
                                className="select-gutter-box"
                                onChange={value => this.onChangeInformation(value, 'currency')}
                                value={information.currency}
                                disabled={information.save_item || information.status_id === orderStatus.SPLIT}
                            >
                                {renderRowCurrency()}
                            </Select>
                        </div>
                        {
                            shipperInformation.handlingChargeFlg ?
                            <div className="gutter-box">
                            <h3 className='title-field'>HANDLING CHARGE</h3>
                            <InputFormat
                                className="select-gutter-box"
                                value={information.HandlingCharge}
                                disabled={information.save_item || information.status_id === orderStatus.SPLIT}
                                onChange={value => this.onChangeInformation(value, 'HandlingCharge')}
                                decimal={[15,2]}
                                isRedstar={false}
                                allowNegative={false}
                            />
                            </div>
                            :
                            ""
                        }
                        {
                            toViewCollectAmount ?
                            <div className="gutter-box">
                            <h3 className='title-field'>Collect Amount</h3>
                            <InputFormat
                                className="select-gutter-box"
                                value={information.CollectAmount}
                                disabled={information.save_item || information.status_id === orderStatus.SPLIT}
                                onChange={value => this.onChangeInformation(value, 'CollectAmount')}
                                decimal={[15,2]}
                                isRedstar={false}
                                allowNegative={false}
                            />
                            </div>
                            : ""
                        }
                    </Col>
                </Row>
            </Col>
        )
    }
}

export default ShipmentOptionsComponent



// WEBPACK FOOTER //
// ./src/containers/orders/components/shipment-options/index.js